import moment from 'moment';

export default {
  phases: {
    phase1Date: moment('2017-12-28 16:00:00'),
    phase2Date: moment('2018-01-11 15:00:00'),
  },
};



// WEBPACK FOOTER //
// ./src/config/settings.js